// TODO: use the language of the course
export function createLangString(text: string) {
  return {
    'hu-HU': text
  };
}
